// extracted by mini-css-extract-plugin
export var flowchartContainer = "_n-0";